import {
    LOAD_TERMS_LIST,
    RECEIVE_TERMS_LIST,
    GET_FILTERED_LIST,
    SELECT_TERM,
    GET_SELECTED_TERM,
    GET_RELATED_TERMS,
    SELECT_COUNTRY,
    SEARCH_FOR_TERM,
    TOGGLE_ICON_VIEW,
    TOGGLE_FAVOURITES_VIEW,
    TOGGLE_FAVOURITE,
    SET_FILTERED_LIST

} from '../actions';

import _ from 'lodash';

export default function (state = {
    termsList: [],
    filteredList: [],
    selectedTerm: {termName: ""},
    relatedTermsList: [],
    countryFilter: 'en-AU',
    level: '1',
    searchTerm:'',
    isIconView: true,
    isFavouritesView: false,
    fetching: false,
}, action) {

    const newState = _.clone(state);

    switch(action.type) {
        case LOAD_TERMS_LIST:
            /*if(!action.payload){
                newState.termsList = [];
            } else {
                newState.termsList = action.payload;
            }*/
            newState.fetching = true;
            return newState;

        case RECEIVE_TERMS_LIST:
            newState.termsList = action.payload;
            newState.baseUrl = action.url;
            newState.fetching = false;
            newState.filteredList = action.payload.sort((a, b) => {
              if (a.termName.toLowerCase() > b.termName.toLowerCase()) {
                return 1;
              } else if (a.termName.toLowerCase() < b.termName.toLowerCase()) {
                return -1;
              }
              return 0;
            });
            newState.selectedTerm = newState.filteredList[0];
            return newState;

        case GET_FILTERED_LIST:
            newState.filteredList = [];
            for (let i = 0; i < newState.termsList.length; i++){
                if ((action.payload === 'all') || newState.termsList[i].age_group === action.payload) {
                    newState.filteredList.push(newState.termsList[i]);
                }
            }
            newState.selectedTerm = newState.filteredList[0];
            return newState;

        case SET_FILTERED_LIST:
            newState.filteredList = action.payload;
            newState.selectedTerm = newState.filteredList[0];
            return newState;


        case SELECT_TERM:
            const { termName, level } = action.payload;
            for (let i = 0; i < state.termsList.length; i++){
                if (state.termsList[i].termName === termName && state.termsList[i].age_group === level ){
                    newState.selectedTerm = state.termsList[i];

                    return newState;
                }
            }
            return state;

        case GET_SELECTED_TERM:
            return newState;

        case GET_RELATED_TERMS:
            if (action.payload !== []){
                newState.relatedTermsList = action.payload;
                return newState;
            } else {
                return state;
            }

        case SELECT_COUNTRY:
            newState.countryFilter = action.payload;
            newState.isFavouritesView = false;
            return newState;

        case SEARCH_FOR_TERM:
            newState.searchTerm = action.payload.toLowerCase();
            newState.filteredList = [];
            for (let i = 0; i < newState.termsList.length; i++){
                if(newState.termsList[i].termName.toLowerCase().includes(newState.searchTerm)){
                    newState.filteredList.push(newState.termsList[i]);
                }
            }
            newState.isFavouritesView = false;
            return newState;

        case TOGGLE_ICON_VIEW:
            newState.isIconView = !newState.isIconView;
            return newState;

        case TOGGLE_FAVOURITES_VIEW:
            newState.isFavouritesView = action.payload.isFavouritesView;
            return newState;

        case TOGGLE_FAVOURITE:
            newState.selectedTerm.isFavourite = !state.selectedTerm.isFavourite;
            return newState;

        default:
            return state;
    }
}
